
import { useStoryblokBridge, useStoryblokApi } from '@storyblok/nuxt-2';
import { mapState } from 'vuex';

export default {
  name: 'GenericPage',
  head() {
    return this.$utils.head(this.story)
  },
  computed:{
    ...mapState(['location', 'cart']),
    isMenuPage() {
      return this.$route.path === '/menu' || this.$route.path === '/menu/'
    },
    isOrderPage() {
      return this.$route.path === '/order' || this.$route.path === '/order/'
    },
    isFranchise() {
      return process.env.IS_FRANCHISE === 'true'
    }
  },
  async asyncData({ $utils, params}) {

    let route = params.pathMatch || ''
    if (route !== '/' && route.endsWith('/')) {
      route = route.replace(/\/+$/, '') || '/'
    }

    const storySlug = (process.env.IS_FRANCHISE
      ? (route ? `franchise/${route}` : 'franchise/')
      : (route || 'home'))

    if (process.env.SB_PREVIEW) {
      const storyblokApi = useStoryblokApi()
      // Redirects/addRoutes can prefix the franchise folder twice (e.g. "franchise/franchise/<slug>").
      // Collapse only that exact duplicate; a plain substring replace corrupts slugs that themselves
      // start with "franchise" (e.g. "franchise/franchiseesupport" -> "franchiseesupport" -> 404).
      let previewSlug = storySlug.replace(/^franchise\/franchise\//, 'franchise/')
      if (previewSlug === 'franchise/franchise') {
        previewSlug = 'franchise'
      }
      const { data } = await storyblokApi.get(`cdn/stories/${previewSlug}`, {
        version: 'draft',
      })

      return {
        story: data.story
      }
    }

    if (process.env.IS_FRANCHISE === 'true') {
      return {
        story: await $utils.content(storySlug)
      }
    }

    return {
      story: await $utils.content(storySlug)
    }
  },
  beforeMount() {
    if (this.isFranchise) {
      return;
    }
    if (this.isMenuPage || this.isOrderPage) {
      let path = '';
      if(this.cart && this.cart.menu_id) {
        path = `/menu/${this.cart.menu_id}`
      }
      else if(this.location && this.location.menu_id) {
        path = `/menu/${this.location.menu_id}`
      }
      else {
        path = '/locations'
      }
      this.$nuxt.$router.push({
        path,
        query: this.$route.query
      })
    }
    // must be at the end
    if(!this.isMenuPage && !this.story) {
      this.$nuxt.$router.push('/404');
    }
  },
  mounted() {
    if (process.env.SB_PREVIEW && this.story?.id) {
      useStoryblokBridge(this.story.id, newStory => (this.story = newStory))
    }
  }
}
